module.exports = __webpack_public_path__ + "assets/img/8.6d2f49ca.png";